import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
import minus from '../../../../assets/images/minus.svg';
import plus from '../../../../assets/images/plus.svg';
// import clock from '../../../../assets/images/clock.svg';

const ServiceApartment = props => {
  // const { t } = useTranslation();
  // const language = getLanguage(useLocation());
  const { topicActive, detailTopic, listArea } = props;

  const [isShowCollapse, setIsShowCollapse] = useState({ key: '', value: false });

  const renderArea = () => {
    if (listArea && listArea.length) {
      return listArea.map((item, index) => (
        <div key={index} className="useful-right useful-area">
          <div className="useful-head jp-bold-600">{item.cityName}</div>
          <div className="">
            {item.districts && item.districts.length
              ? item.districts.map((item, index) => {
                  return (
                    <div key={index} className="main-content">
                      <div
                        className={`useful-content click-collapse ${
                          isShowCollapse.key === item.districtId && isShowCollapse.value ? 'actived' : 'collapsed'
                        }`}
                        onClick={() =>
                          setIsShowCollapse({
                            key: item.districtId,
                            value: !(isShowCollapse.key === item.districtId && isShowCollapse.value),
                          })
                        }
                      >
                        <div className="useful-title">{item.districtName || ''}</div>
                        <img
                          src={isShowCollapse.key === item.districtId && isShowCollapse.value ? minus : plus}
                          className="img-plus"
                          alt=""
                        />
                      </div>
                      <div
                        className={`useful-description collapse ${
                          isShowCollapse.key === item.districtId && isShowCollapse.value ? 'show' : ''
                        }`}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.description || '',
                          }}
                        ></div>
                        <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.image}`} alt="" />
                      </div>
                    </div>
                  );
                })
              : ''}
          </div>
        </div>
      ));
    }
  };

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  return (
    <>
      <div className="main-useful-right main-useful-apartment content-useful">
        {topicActive && detailTopic && topicActive.slug === 'area-guide' ? (
          <>
            <div className="useful-content-title useful-area-guide">
              <div className="title jp-bold-600">{detailTopic && detailTopic.title ? detailTopic.title : ''}</div>
              <div
                className="jp-font-sawarabi-gothic"
                dangerouslySetInnerHTML={createMarkup(detailTopic?.content)}
              ></div>
            </div>
            {renderArea()}
          </>
        ) : (
          <>
            <div className="useful-content-title">
              <div className="title jp-bold-600">{detailTopic && detailTopic.title ? detailTopic.title : ''}</div>
              <div
                className="jp-font-sawarabi-gothic"
                dangerouslySetInnerHTML={createMarkup(detailTopic?.content)}
              ></div>
              {/* <div className="update-day">
                <img src={clock} alt="" className="icon-clock" />
                {detail && detail.publicDate
                  ? language === 'en'
                    ? moment(detail.publicDate).format('MMM DD, YYYY')
                    : moment(detail.publicDate).format('YYYY-MM-DD')
                  : ''}
              </div> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ServiceApartment;
